"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTooltip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var LineChartTooltip_1 = require("./LineChartTooltip");
var ScatterChartTooltip_1 = require("./ScatterChartTooltip");
var BarChartTooltip_1 = require("./BarChartTooltip");
var LineBarChartTooltip_1 = require("./LineBarChartTooltip");
var PeakTroughTooltip_1 = require("./PeakTroughTooltip");
var StackedBarChartTooltip_1 = require("./StackedBarChartTooltip");
var TooltipContent = function (_a) {
    var type = _a.type, data = _a.data, colorScale = _a.colorScale, _b = _a.dataLabel, dataLabel = _b === void 0 ? '' : _b, _c = _a.colorCodeValues, colorCodeValues = _c === void 0 ? true : _c;
    switch (type) {
        case 'SCATTER':
            return (react_1.default.createElement(ScatterChartTooltip_1.ScatterChartTooltip, { data: data, colorScale: colorScale }));
        case 'BAR':
            return (react_1.default.createElement(BarChartTooltip_1.BarChartTooltip, { data: data, colorScale: colorScale, dataLabel: dataLabel, colorCodeValues: colorCodeValues }));
        case 'STACKED_BAR':
            return (react_1.default.createElement(StackedBarChartTooltip_1.StackedBarChartTooltip, { data: data, colorScale: colorScale, colorCodeValues: colorCodeValues }));
        case 'HISTOGRAM':
            return (react_1.default.createElement(BarChartTooltip_1.BarChartTooltip, { data: data, colorScale: colorScale, dataLabel: dataLabel, colorCodeValues: colorCodeValues, histogram: true }));
        case 'LINE_BAR':
            return (react_1.default.createElement(LineBarChartTooltip_1.LineBarChartTooltip, { data: data, colorScale: colorScale, dataLabel: dataLabel }));
        case 'PEAK_TROUGH':
            return (react_1.default.createElement(PeakTroughTooltip_1.PeakTroughTooltip, { data: data }));
        default:
            return (react_1.default.createElement(LineChartTooltip_1.LineChartTooltip, { data: data, colorScale: colorScale }));
    }
};
exports.ChartTooltip = react_1.forwardRef(function (_a, ref) {
    var data = _a.data, colorScale = _a.colorScale, type = _a.type, _b = _a.dataLabel, dataLabel = _b === void 0 ? '' : _b, colorCodeValues = _a.colorCodeValues, rest = tslib_1.__rest(_a, ["data", "colorScale", "type", "dataLabel", "colorCodeValues"]);
    return (react_1.default.createElement(StyledContainer, tslib_1.__assign({ ref: ref }, rest, { "data-test-component-name": "chart-tooltip" }),
        react_1.default.createElement(TooltipContent, { data: data, colorScale: colorScale, type: type, dataLabel: dataLabel, colorCodeValues: colorCodeValues })));
});
exports.ChartTooltip.displayName = 'FOS_ChartTooltip';
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  visibility: hidden;\n  opacity: 0;\n  display: inline-block;\n  position: absolute;\n  z-index: 10010;\n"], ["\n  visibility: hidden;\n  opacity: 0;\n  display: inline-block;\n  position: absolute;\n  z-index: 10010;\n"])));
var templateObject_1;
